// extracted by mini-css-extract-plugin
export default {"tableWrapper":"LogsTable_tableWrapper__RRx34","table":"LogsTable_table__15rJZ","rowHead":"LogsTable_rowHead__byqEW","row":"LogsTable_row__yJ8sl","col":"LogsTable_col__7L8OE"};